'use client'

import { useEffect } from 'react'
import { recoverFromAssetSkewOnce } from '@/lib/pwa/recoverFromAssetSkew'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log error with unique marker for debugging
    console.error('[APP_ERROR_BOUNDARY] Error:', error)
    console.error('[APP_ERROR_BOUNDARY] Error name:', error?.name)
    console.error('[APP_ERROR_BOUNDARY] Error message:', error?.message)
    if (error?.stack) {
      console.error('[APP_ERROR_BOUNDARY] Error stack:', error.stack)
    }
    if (error?.digest) {
      console.error('[APP_ERROR_BOUNDARY] Error digest:', error.digest)
    }
    void recoverFromAssetSkewOnce(error)
  }, [error])

  return (
    <div className="min-h-screen bg-wag-canvas flex items-center justify-center p-4">
      <div className="text-center max-w-md">
        <h2 className="text-2xl font-bold text-wag-dark mb-4">
          Something went wrong!
        </h2>
        <p className="text-gray-600 mb-6">
          An error occurred while loading the page. Please try again.
        </p>
        <button
          onClick={reset}
          className="bg-wag-primary text-white px-6 py-3 rounded-lg hover:bg-wag-primary/90 transition-colors font-medium"
        >
          Try again
        </button>
      </div>
    </div>
  )
}
